import { enterFullscreen, exitFullscreen, observeFullscreen } from 'bits/fullscreen'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const browser = namespace('browser')

@Component
export default class extends Vue {
  private unobserveFullscreen
  @browser.Getter private isFullscreen
  @browser.Action private enterFullscreen
  @browser.Action private exitFullscreen

  @Watch('isFullscreen')
  private updateFullscreen(): void {
    this.isFullscreen ? enterFullscreen() : exitFullscreen()
  }

  private observeFullscreenHandler(enteringFullscreen: boolean): void {
    const exitingFullscreen = !enteringFullscreen
    if (!this.isFullscreen && enteringFullscreen) this.enterFullscreen()
    if (this.isFullscreen && exitingFullscreen) this.exitFullscreen()
  }

  private mounted(): void {
    this.unobserveFullscreen = observeFullscreen(this.observeFullscreenHandler.bind(this))
  }

  private beforeDestroy(): void {
    this.unobserveFullscreen && this.unobserveFullscreen()
  }
}
